// @flow

import * as React from 'react';

import Button from 'app/common/components/Button';

import { type QuestionType } from 'app/team-guide/utils/constants';

type QuestionProps = {
  questions: Array<QuestionType>,
  onSelect: (view: string) => void,
  className: string,
};

const Questions = ({
  questions,
  onSelect,
  className,
}: QuestionProps): Array<React.Node> =>
  questions.map(({ key, question }: QuestionType) => (
    <Button
      className={className}
      iconAfter="arrow-right"
      key={`questiononly-${key}`}
      kind="block large chameleon team justify-between"
      onClick={() => onSelect(key)}
    >
      <div> {question} </div>
    </Button>
  ));

export default Questions;
